<template>
	<div class="form-loading">
		<UiLoader class="full">
			<BaseCmsLabel code="bankart_hold_loader" tag="span" />
		</UiLoader>
	</div>
	<div v-if="leanpayData">
		<form :action="leanpayData.redirect_url" method="post" name="payment_confirm">
			<span v-html="leanpayData.hidden_form"></span>
			<input id="paymentHiddenButton" class="hidden-form-input" name="" type="submit" :value="labels.get('pay_by_credit_card')" />
		</form>
	</div>
</template>

<script setup>
	const { leanpayData } = useCheckout();
	const labels = useLabels();

	onMounted(() => {
		setTimeout(function(){
			if(leanpayData.value) {
				const paymentButton = document.getElementById('paymentHiddenButton');
				if (paymentButton) {
					paymentButton.click();
				}
			}
		}, 1000)
	})
</script>

<style lang="less" scoped>
	:deep(.loader-text){
		padding: 0 20px;
		p{padding: 0 0 3px; text-transform: none; text-align: center;}
	}
</style>
